import { render, staticRenderFns } from "./DataCenterTable.vue?vue&type=template&id=589e93ed&scoped=true"
import script from "./DataCenterTable.vue?vue&type=script&lang=js"
export * from "./DataCenterTable.vue?vue&type=script&lang=js"
import style0 from "./DataCenterTable.vue?vue&type=style&index=0&id=589e93ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e93ed",
  null
  
)

export default component.exports